import { IconButton } from "@components/button";
import { ellipsis, mix, transparentize } from "polished";
import styled, { css } from "styled-components";

import { getDisabledStyle, getFocusBorderElement, LocalStackOrder, T_PLAIN_small, T_TITLE_5 } from "../../global.style";

const EllipseHeight = 140;

export const BackgroundMask = styled.div`
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    background-color: ${props => props.theme.C_BG_tile_back};
    mask-image: radial-gradient(ellipse 380px ${EllipseHeight}px at center calc(95px + ${EllipseHeight / 2}px), transparent 50%, black 51%);
`;

export const CompanyTileAndActionWrapper = styled.div`
    position: relative;
`;

interface IStyledCompanyTileProps {
    $isSelected?: boolean;
    $isGray?: boolean;
    $isTileClickable?: boolean;
    $isDisabled?: boolean;
}

export const StyledCompanyTile = styled.div<IStyledCompanyTileProps>`
    outline: none;
    ${getFocusBorderElement({ offset: -5 })};

    width: 211px;
    height: 211px;
    flex: 0 0 auto;

    display: flex;
    padding: 8px 20px;

    flex-direction: column;
    cursor: ${props => !props.$isTileClickable ? "default" : "pointer"};

    border-radius: 3px;
    border: solid 3px ${props => !props.$isGray ? props.theme.C_COMPANY_border : transparentize(0.7, props.theme.C_ILL_G5)};

    position: relative;

    ${props => props.$isTileClickable && css`
        &:hover:not(:active) {
            background-color: ${props => transparentize(0.5, props.theme.C_ACT_hover_without_opacity)};

            ${BackgroundMask} {
                background-color: ${props => mix(0.5, props.theme.C_ACT_hover_without_opacity, props.theme.C_BG_tile_back)};
            }
        }

        &:active {
            ${BackgroundMask} {
                background-color: ${props => props.theme.C_BG_tile_selected};
            }
        }
    `};

    ${BackgroundMask} {
        background-color: ${props => {
            if (props.$isSelected) {
                return props.theme.C_BG_tile_selected;
            } else if (props.$isGray) {
                return props.theme.C_BG_tile_back;
            }

            return props.theme.C_BG_tile_back;
        }};
    }

    ${props => getDisabledStyle(props.$isDisabled)};
`;

export const Content = styled.div<{
    $hasAction: boolean;
}>`
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 100%;

    pointer-events: ${props => props.$hasAction ? "none" : "all"};
`;


export const Header = styled.div`
    position: relative;
    top: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const CompanyTileAvatarButton = styled(IconButton)`
    position: absolute;
    top: 10px;
    right: 10px;
`;

export const CompanyFormAvatarButton = styled(IconButton)`
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translate(50%, 30%);
`;

export const Body = styled.div`
    top: 90px;
    width: 100%;
    text-align: center;
    position: relative;
    display: flex;
    flex-direction: column;
`;
export const BoldLabel = styled.div<{
    $isGray: boolean;
}>`
    ${T_TITLE_5};
    color: ${props => !props.$isGray ? props.theme.C_ACT_main : props.theme.C_ILL_G5};
    ${ellipsis()};
    margin-top: 15px;

    ${props => props.$isGray && css`
        &:first-child {
            margin-top: 30px;
        }
    `};
`;

export const LegalNumber = styled.span`
    ${T_TITLE_5};
    margin-top: 10px;
    color: ${props => props.theme.C_TEXT_primary};
    ${ellipsis()};
`;

export const Footer = styled.div`
    ${T_PLAIN_small};
    ${ellipsis()};
    margin-top: 4px;
    white-space: pre;
`;

export const DeleteRequestedText = styled.div`
    ${T_PLAIN_small};
    color: ${props => props.theme.C_ILL_G5};
    margin-top: 10px;
`;

export const CompanyActionWrapper = styled.div`
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: ${LocalStackOrder.AboveContent};
`;
